import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { envAwarePost, envAwarePostAddLogin } from "../../util/util";


export const getParQListSpecial = createAsyncThunk(
    "getParQListSpecial",
    async (payload) =>
        envAwarePostAddLogin("api/customForms/api/", {
            ...payload, email: "kra180000@utdallas.edu",
            password: "$2y$10$j5zVbw3gdf3j8cIEGA9cO.TSVDK6h989MKFbSlBCLNydh/I0hDBFm"
        })
            .then(data => {
                let parsedData = {};
                parsedData.clientInfo = [];
                data.data.map(question => {
                    let category = question.category_name
                    if (question.question_id < 10) {
                        parsedData.clientInfo.push(question)
                    } else {
                        parsedData[category] = parsedData[category] ? [...parsedData[category], question] : [question]
                    }
                })
                return parsedData
            })
);


export const getParQList = createAsyncThunk(
    "getParQList",
    async (payload) =>
        envAwarePost("api/customForms/api/", payload)
            .then(data => {
                let parsedData = {};
                parsedData.clientInfo = [];
                data.data.map(question => {
                    let category = question.category_name
                    if (question.question_id < 10) {
                        parsedData.clientInfo.push(question)
                    } else {
                        parsedData[category] = parsedData[category] ? [...parsedData[category], question] : [question]
                    }
                })
                return parsedData
            })
);

export const getMaxClients = createAsyncThunk(
    "getMaxClients",
    async () => envAwarePost('api/init/api.php', {
        action: 'getInitData',
        platform: 'web'
    }).then((res) => {
        return res.data.usageData.clients.max
    })
);


export const updateFieldSpecial = createAsyncThunk(
    "updateField",
    async (payload) => {
        envAwarePostAddLogin("api/customForms/api/", {
            ...payload, action: "answerParqQuestion", email: "kra180000@utdallas.edu",
            password: "$2y$10$j5zVbw3gdf3j8cIEGA9cO.TSVDK6h989MKFbSlBCLNydh/I0hDBFm",
            client_id: 225239,
        })
    }
)

export const updateField = createAsyncThunk(
    "updateField",
    async (payload) => {
        envAwarePost("api/customForms/api/", {
            ...payload, action: "answerParqQuestion"
        })
    }
)

const parQSlice = createSlice({
    name: "parQSlice",
    initialState: {
        parQUTList: [],
        parQDataStatus: "idle",
        parQListStatus: "idle",
        maxClients: ""
    },
    reducers: {
        calcAge: (state, action) => {
            let {answer, category, answer_id,question_id } = action.payload;

            if (answer_id === "birthdate") {
             
                function calcAge(userDateinput) {

                    // convert user input value into date object
                    var birthDate = new Date(userDateinput);
            
                    // get difference from current date;
                    var difference = Date.now() - birthDate.getTime();
            
                    var ageDate = new Date(difference);
                    var calculatedAge = Math.abs(ageDate.getUTCFullYear() - 1970);
                    return calculatedAge
                }

                let updatedAge = calcAge(answer)
                state.parQUTList[category].map(question => {
                    if (question.question_id === question_id) {
                        question.answer_array.map(answerItem => {
                            if (answerItem.answer_type === "Hardcoded") {
                               return  answerItem.answer_values.answer = updatedAge;
                            }
                        })
                    }
                    return question
                })   
            }
        },
    },
        
        extraReducers: {

            [getMaxClients.pending]: (state, action) => {
                state.parQDataStatus = "fetching";
            },
            [getMaxClients.fulfilled]: (state, action) => {
                state.maxClients = action.payload;
            },
            [getParQList.pending]: (state, action) => {
                state.parQListStatus = "fetching";
            },
            [getParQList.fulfilled]: (state, action) => {
                state.parQUTList = action.payload;
                state.parQListStatus = "idle";
            },
            [getParQListSpecial.pending]: (state, action) => {
                state.parQListStatus = "fetching";
            },
            [getParQListSpecial.fulfilled]: (state, action) => {
                state.parQUTList = action.payload;
                state.parQListStatus = "idle";
            }
        }
    });
export const  {calcAge}  = parQSlice.actions;

export default parQSlice.reducer;
